export const locale = {
  lang: 'en',
  'datatable' : {
    'SEARCH': 'Buscar',
   }
};
